import { render, staticRenderFns } from "./index_page.vue?vue&type=template&id=38165db2&"
import script from "./index_page.vue?vue&type=script&lang=js&"
export * from "./index_page.vue?vue&type=script&lang=js&"
import style0 from "./index_page.vue?vue&type=style&index=0&id=38165db2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports